<template>
  <div class="footer">
    <div class="top">
      <router-link class="left"
                   to="index">
        <img class="logo"
             :src="logo"
             onerror="@/assets/images/ic_logo.png">
      </router-link>
      <div class="describe">
        <el-row type="flex"
                justify="space-between">
          <el-col v-if="helpList && helpList.length"
                  :span="4">
            <p>帮助中心</p>
            <ul class="title_li">
              <li v-for="(item,index) in helpList"
                  :key="index"
                  @click="goArticleDetail(item,1)">{{item.classifyName}}</li>
            </ul>
          </el-col>
          <el-col v-if="systemlist && systemlist.length"
                  :span="4">
            <p>系统快报</p>
            <ul class="title_li">
              <li v-for="(item,index) in systemlist"
                  :key="index"
                  @click="goArticleDetail(item,2)">{{item.classifyName}}</li>
            </ul>
          </el-col>
          <el-col v-if="noticeList && noticeList.length"
                  :span="4">
            <p>商城公告</p>
            <ul class="title_li">
              <li v-for="(item,index) in noticeList"
                  :key="index"
                  @click="goArticleDetail(item,3)">{{item.classifyName}}</li>
            </ul>
          </el-col>
<!--          <el-col v-if="businessList && businessList.length"
                  :span="4">
            <p>电商快报</p>
            <ul class="title_li">
              <li v-for="(item,index) in businessList"
                  :key="index"
                  @click="goArticleDetail(item,4)">{{item.classifyName}}
              </li>
            </ul>
          </el-col>-->
          <el-col v-if="distributionList && distributionList.length"
                  :span="4">
            <p>分销须知</p>
            <ul class="title_li">
              <li v-for="(item,index) in distributionList"
                  :key="index"
                  @click="goArticleDetail(item,12)">{{item.classifyName}}</li>
            </ul>
          </el-col>
        </el-row>
      </div>
      <!--      <Row type="flex" :gutter="10" class="code_img">-->
      <!--        <Col>-->
      <!--          <img src="@/assets/images/erweima.png" alt="">-->
      <!--          <p>公众号</p>-->
      <!--        </Col>-->
      <!--        <Col>-->
      <!--          <img src="@/assets/images/erweima.png" alt="">-->
      <!--          <p>小程序</p>-->
      <!--        </Col>-->
      <!--      </Row>-->
    </div>
    <div class="bottom">
      <div>
        <span  v-html="qqInfo.name">
<!--          {{item.name}}：
          <a style="padding: 0;"
             :href="'http://wpa.qq.com/msgrd?v=3&uin=' + item.value + '&site=qq&menu=yes'"
             target="_blank">{{item.value}}</a>-->
        </span>
        热线电话：
        <a style="padding: 0;"
           :href="'tel:' + servicePhone">{{servicePhone}}</a>
      </div>
      Copyright 2020 , All Rights Reserved ICP证 ：{{icp}} 版权所有：{{company}}
    </div>
  </div>
</template>

<script>
import { configData, getNewsListByParentId } from '@/api/login'

export default {
  name: 'BottomFooter',
  data() {
    return {
      logo: require('@/assets/images/ic_logo.png'),
      company: '中国鞋库网',
      icp: 'TCP982491923',
      serviceList: [],
      qqInfo: {},
      servicePhone: null,
      helpList: [],
      systemlist: [],
      distributionList: [],
      businessList: [],
      noticeList: []
    }
  },
  created() {
    if (this.$store.state.mallLogo) {
      this.logo = this.$store.state.mallLogo
    }
    this.init()
  },
  methods: {
    getNewsListByParentId() {
      // 帮助中心
      getNewsListByParentId({ parentId: 1, pageNum: 1, pageSize: 4 }).then(res => {
        res.data.forEach(item => {
          this.helpList.push({
            id: item.id,
            classifyName: item.classifyName,
            classifyLevel: item.classifyLevel
          })
        })
      })
      // 系统快报
      getNewsListByParentId({ parentId: 2, pageNum: 1, pageSize: 4 }).then(res => {
        res.data.forEach(item => {
          this.systemlist.push({
            id: item.id,
            classifyName: item.classifyName,
            classifyLevel: item.classifyLevel
          })
        })
      })
      // 电商快报
      getNewsListByParentId({ parentId: 4, pageNum: 1, pageSize: 4 }).then(res => {
        res.data.forEach(item => {
          this.businessList.push({
            id: item.id,
            classifyName: item.classifyName,
            classifyLevel: item.classifyLevel
          })
        })
      })
      // 分销须知
      // getNewsListByParentId({parentId:12,pageNum:1,pageSize: 4}).then(res => {
      //   res.data.forEach(item => {
      //     this.distributionList.push({
      //       id: item.id,
      //       classifyName: item.classifyName,
      //       classifyLevel: item.classifyLevel
      //     })
      //   })
      // })
      // 商城公告
      getNewsListByParentId({ parentId: 3, pageNum: 1, pageSize: 4 }).then(res => {
        res.data.forEach(item => {
          this.noticeList.push({
            id: item.id,
            classifyName: item.classifyName,
            classifyLevel: item.classifyLevel
          })
        })
      })
    },
    goAdmin() {
      // 前往卖家工作台
      window.open(this.ADMIN_URL, '_blank')
    },
    init() {
      configData({ key: 'P_mallLogo', tips: '商城Logo' }).then(res => {
        if (res.data && res.data.name) {
          this.logo = res.data.name
        }
      })
      configData({ key: 'P_serviceQQ', tips: '客服qq' }).then(res => {
        this.qqInfo = res.data
        let value = res.data.name
        if (value) {
          value = value.split(/,|，/g)
          this.serviceList = value.map(item => {
            let arr = item.split('|')
            return { name: arr[0], value: arr[1] }
          })
        }
      })
      configData({ key: 'P_servicePhone', tips: '客服电话' }).then(res => {
        if (res.data && res.data.name) {
          this.servicePhone = res.data.name
        }
      })
      configData({ key: 'J_mallIcp', tips: 'ICP证书或ICP备案证书号' }).then(res => {
        if (res.data && res.data.name) {
          this.icp = res.data.name
        }
      })
      configData({ key: 'P_companyName', tips: '公司名称' }).then(res => {
        if (res.data && res.data.name) {
          this.company = res.data.name
        }
      })
      this.getNewsListByParentId()
    },
    goArticleDetail(item, type) {
      let url = process.env.MARKET_DOMAIN + '/help-' + item.id
      window.open(url, '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
.footer {
  width: 100%;
  background: white;
}

.top {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 1200px;
  margin: 0 auto;
  padding: 45px 20px 50px 20px;
}

.left {
  .logo {
    width: 250px;
    padding-right: 55px;
    border-right: 1px solid #ccc;
  }
}

.describe {
  flex: 1;
  margin: 0 55px;
  text-align: left;
}

.describe p {
  font-size: 16px;
  color: #5b5b5b;
}

.describe ul {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding-inline-start: 0;
  list-style: none;
}

.title_li {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  font-size: 14px;
  color: #8e8e8e;
  margin-top: 5px;
}

.title_li li:nth-child(1) {
  cursor: pointer;
}

.code_img {
  font-size: 12px;
  color: #999999;

  img {
    width: 80px;
    height: 80px;
  }
}

.bottom {
  padding: 30px 0;
  text-align: center;
  font-size: 12px;
  font-weight: 500;
  color: #666666;
  line-height: 33px;
  border-top: 1px solid #f5f5f5;
}
</style>



// WEBPACK FOOTER //
// src/views/login/components/BottomFooter.vue